import { render, staticRenderFns } from "./BatteryUsageChart.vue?vue&type=template&id=11bb63e9&"
import script from "./BatteryUsageChart.vue?vue&type=script&lang=js&"
export * from "./BatteryUsageChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports